import { render, staticRenderFns } from "./SignScreen.vue?vue&type=template&id=7bd27cff&scoped=true&"
import script from "./SignScreen.vue?vue&type=script&lang=js&"
export * from "./SignScreen.vue?vue&type=script&lang=js&"
import style0 from "./SignScreen.vue?vue&type=style&index=0&id=7bd27cff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd27cff",
  null
  
)

export default component.exports